export default __webpack_public_path__ + "static/media/close-icon-no-color.97a3d537.svg";